import {
  InputGroupProps
} from "./InputGroup.types";
import {
  Stack
} from "../../Layouts/Stack/Stack.page";
import {
  HelperText,
  Label
} from "../../Display";

export function InputGroup({
  className,
  children,
  helperText,
  inputProps,
  required,
  error,
  label,
  rule,
  childrenDirection = 'row',
  childrenGap = 4,
  ...props
}: InputGroupProps) {

  return (
    <Stack direction="col" gap={0.5} className={className}>
      {(!!label) && <Label {...{ required, error }}>{label}</Label>}
      <Stack direction={childrenDirection} gap={childrenGap} {...props}>{children}</Stack>
      {(!!helperText) && <HelperText {...{ error }}>{helperText}</HelperText>}
    </Stack>
  );
}
